( function ( app, core ) {
    'use strict';

    app.PoolsTabs = function ( widget ) {
        const _self = this;

        _self.container = widget;
        const hideTabs = document.querySelector( '.js-hide-tabs' );

        if ( hideTabs ) {

            core.style.addClass( _self.container, 'u-hide' );
        } else {
            _self.tabs = document.querySelectorAll( '.js-pools-tab' );
            _self.itemList = document.querySelectorAll( '.pools' );
            _self.setListeners();
        }
    };

    app.PoolsTabs.prototype.setListeners = function () {
        const _self = this;
        _self.itemList.forEach( ( item, index ) => {
            if ( index === 1 ) {
                core.style.addClass( item, 'u-hide' );
            }
        });
        _self.tabs.forEach((tab) => {
            tab.addEventListener('click', ( event ) => {
                event.preventDefault();
                const anchorTab = tab.dataset.tab;
                _self.contentSwitcher(event, anchorTab);
            });
        });
    };

    app.PoolsTabs.prototype.contentSwitcher = function ( evt, tab ) {
        const _self = this;
        const activeTab = document.querySelector( `[ data-tab="${ tab }" ]` );
        _self.itemList.forEach( item => {
            if ( item.dataset.gender !== tab ) {
                core.style.addClass( item, 'u-hide');
            } else {
                core.style.removeClass( item, 'u-hide' );
            }
        });

        _self.tabs.forEach( tab => {
            core.style.removeClass( tab, 'isActive' );
            core.style.addClass( evt.target, 'isActive' );
        });
    };
    let widgets = document.querySelectorAll( '[data-widget="pools-tabs"]' );

    Array.prototype.forEach.call( widgets, function ( widget ) {
        new app.PoolsTabs( widget );
    });
})( PULSE.app, PULSE.core, PULSE.ui );
